module.exports = __webpack_public_path__ + "img/blacklist-blank-state.47c3d306.svg";